import { render, staticRenderFns } from "./RationsTableMobile.vue?vue&type=template&id=059a5b1e&scoped=true&lang=pug&"
import script from "./RationsTableMobile.vue?vue&type=script&lang=js&"
export * from "./RationsTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./RationsTableMobile.vue?vue&type=style&index=0&id=059a5b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a5b1e",
  null
  
)

export default component.exports